var map = {
	"./1.jpg": 1073,
	"./IMG_20240228_141400 (1).jpg": 1074,
	"./received_1372512850107097 (1).jpeg": 1075,
	"./received_3579201952296323 (1).jpeg": 1076,
	"./received_427461033551410 (1).jpeg": 1077,
	"./received_436266258860996 (1).jpeg": 1078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1801;